import { Form } from 'react-router';
import { Button } from '~/common/components/ui/button';
import { LucideX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { FilterDefinition } from '~/features/catalog/types/filterDefinition';
import type { ISearchRequestDTOData } from '~/dtos/ProdegaApiWebshop-api-typings-generated';

export interface FilterResetProps {
  filters: FilterDefinition[];
  liveSearchRequest: ISearchRequestDTOData;
}

export function FilterReset({ filters, liveSearchRequest }: Readonly<FilterResetProps>) {
  const { t } = useTranslation();

  const hasActiveFilters = filters.some(filter => filter.active);

  if (!hasActiveFilters) {
    return null;
  }

  return (
    <Form className={'flex justify-end'}>
      {/* hidden input to keep the search term */}
      {liveSearchRequest.searchTerm && <input hidden name="searchTerm" defaultValue={liveSearchRequest.searchTerm} />}
      <Button size={'default'} variant={'link'} className={'m-0 p-0 h-fit'} data-testid={'filter-reset-button'}>
        <LucideX size={16} />
        <div className={'ml-1 text-sm'}>{t('Alle Filter zurücksetzen')}</div>
      </Button>
    </Form>
  );
}
